// extracted by mini-css-extract-plugin
module.exports = {"separator":"widget-demo--separator--thZ68","informative":"widget-demo--informative--16lgT","separatorText":"widget-demo--separatorText--2OnDL"};